"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AVIARY_ACCENTS = void 0;
var AVIARY_ACCENTS = {
  forest: "forest",
  sand: "sand"
};
exports.AVIARY_ACCENTS = AVIARY_ACCENTS;